import { Constants } from '.'

export const get = () => ({
  type: Constants.USER_GET
})

export const getSuccess = payload => ({
  type: Constants.USER_GET_SUCCESS,
  payload
})

export const getFailure = error => ({
  type: Constants.USER_GET_FAILURE,
  error
})

export const setProfilePreferences = (payload) => ({
  type: Constants.USER_SET_PROFILE_PREFERENCES,
  payload
})

export const setProfilePreferencesSuccess = () => ({
  type: Constants.USER_SET_PROFILE_PREFERENCES_SUCCESS
})

export const setProfilePreferencesFailure = (error) => ({
  type: Constants.USER_SET_PROFILE_PREFERENCES_FAILURE,
  error
})
